<template>
  <div id="basic">
    <el-row :gutter="10">
      <el-col :lg="14" :md="14">
        <!-- <div class="istopflex" style="display: flex; margin-bottom: 20px"> -->
        <div style="display: flex">
          <div style="margin-right: 20px; line-height: 40px">选择门店：</div>
          <el-select
            v-model="formInline.id"
            placeholder="请选择"
            @change="getList"
          >
            <el-option
              v-for="index in typeDate"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </div>

        <!-- </div> -->
      </el-col>
      <el-col :lg="10" :md="10">
        <div style="display: flex">
          <!-- <el-date-picker
            v-model="formInline.date"
            type="daterange"
            unlink-panels
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          ></el-date-picker> -->
          <!-- <el-date-picker
            v-model="formInline.date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker> -->

<!--          <el-date-picker-->
<!--            v-model="formInline.date"-->
<!--            type="daterange"-->
<!--            align="right"-->
<!--            range-separator="至"-->
<!--            start-placeholder="开始日期"-->
<!--            end-placeholder="结束日期"-->
<!--            value-format="yyyy-MM"-->
<!--            :picker-options="pickerOptions"-->
<!--          >-->
<!--          </el-date-picker>-->
          <el-date-picker
              v-model="formInline.date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
          </el-date-picker>

          <!-- <el-date-picker
            v-model="formInline.date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
          >
          </el-date-picker> -->

          <el-button @click="getDateTop" style="margin-left: 10px"
            >查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col class="colMaxBox" :lg="4" :md="12"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              销售额 <i class="el-icon-s-marketing iconFloat iconCol3"></i>
            </div>
            <div class="item_value">¥{{ total_saleall | priceFilt }}</div>
          </div>
        </div>
      </el-col>

      <el-col class="colMaxBox" :lg="5" :md="12"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              充值额 <i class="el-icon-s-promotion iconFloat iconCol4"></i>
            </div>
            <div class="item_value">¥{{ prepay_saleall | priceFilt }}</div>
          </div>
        </div>
      </el-col>
      <el-col class="colMaxBox" :lg="5" :md="12"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              支付宝消费金额
              <i class="el-icon-s-shop iconFloat iconCol5"></i>
            </div>
            <div class="item_value">¥{{ ali_saleallall | priceFilt }}</div>
          </div>
        </div>
      </el-col>
      <el-col class="colMaxBox" :lg="5" :md="12"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              微信消费金额 <i class="el-icon-s-help iconFloat iconCol1"></i>
            </div>
            <div class="item_value">¥ {{ wechat_saleall | priceFilt }}</div>
          </div>
        </div>
      </el-col>
      <el-col class="colMaxBox" :lg="5" :md="24"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              会员余额消费 <i class="el-icon-s-finance iconFloat iconCol2"></i>
            </div>
            <div class="item_value">¥{{ member_saleall | priceFilt }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back">
          <div id="echart_C" style="width: 100%; height: 300px"></div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back">
          <div id="echart_B" style="width: 100%; height: 300px"></div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back">
          <div id="echart_A" style="width: 100%; height: 300px"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        id: '',
        category_type: 1, // c_type|| 2外卖  1堂食
        date: null,
      },
      datalist: [],
      topValue: {},
      typeDate: [],
      total_saleall: 0,
      prepay_saleall: 0,
      ali_saleallall: 0,
      wechat_saleall: 0,
      member_saleall: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            },
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.$root.headName = ['运营数据', '资金管理'];
  },
  mounted() {
    this.getType();
    //
  },
  methods: {
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.formInline.date = [this.fastDate(true), this.getDate(true)];
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    drawLine() {
      let elementById = document.getElementById('echart_A');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
          value = [];

      const exlist = this.topValue['client_stat_day'];
      if (exlist) {
        exlist.map((item) => {
          data.push(item.day);
          value.push(item.count);
        });
      }
      let option = {
        title: {
          text: '客流曲线',
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data,
        },
        yAxis: {
          type: 'value',

          splitLine: { show: false },
        },
        series: [
          {
            name: '当日就餐人数',
            type: 'line',
            color: '#004cff',
            stack: '总量',
            data: value,
            label: {
              show: true,
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },

    drawLines() {
      let elementById = document.getElementById('echart_B');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
        value = [];

      const exlist = this.topValue['order_stat_day'];
      if (exlist) {
        exlist.map((item) => {
          data.push(item.day);
          value.push(item.count);
        });
      }
      let option = {
        title: {
          text: '30天订单平均值',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['30天订单数量'],
          // , '实付金额最小值', '实付金额最大值'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          // data: [
          //   '2021-9-1',
          //   '2021-9-2',
          //   '2021-9-3',
          //   '2021-9-4',
          //   '2021-9-5',
          //   '2021-9-6',
          //   '2021-9-7',
          // ],
          data: data,
        },
        yAxis: {
          type: 'value',

          splitLine: { show: false },
        },
        series: [
          {
            name: '实付订单量',
            type: 'line',
            color: '#004cff',
            stack: '总量',
            data: value,
            smooth: true,
            // data: [220, 302, 181, 234, 210, 290, 150],
            label: {
              show: true,
            },
          },
          // {
          //   name: '实付金额最大值',
          //   type: 'line',
          //   color: '#fb6c6c',
          //   stack: '总量',
          //   // data: value,
          //   smooth: true,
          //   data: [220, 502, 281, 264, 250, 490, 250],
          //   label: {
          //     show: true,
          //   },
          // },
          // {
          //   name: '实付金额最小值',
          //   type: 'line',
          //   color: '#f6ee1b',
          //   stack: '总量',
          //   data: value,
          //   data: [220, 502, 281, 264, 250, 490, 250],
          //   smooth: true,
          //   label: {
          //     show: true,
          //   },
          // },
        ],
      };
      echartsDemo.setOption(option);
    },
    drawLinex() {
      let elementById = document.getElementById('echart_C');
      let echartsDemo = this.$echarts.init(elementById);
      let data = [],
        value = [],
        total_saleall = 0;
      const exlist = this.topValue['total_sale_month'];
      if (exlist) {
        exlist.map((item) => {
          data.push(item.month);
          value.push(item.total_price / 100);
          total_saleall += item.total_price;
        });
      }
      this.total_saleall = total_saleall / 100 || 0;

      let option = {
        color: ['#41ec82'],
        title: {
          text: '营收曲线',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        legend: {
          data: ['Line 1'],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: data,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '当月营收',
            type: 'line',
            stack: '总量',
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: 'top',
            },
            areaStyle: {
              opacity: 0.8,
            },
            emphasis: {
              focus: 'series',
            },
            data: value,
          },
        ],
      };
      echartsDemo.setOption(option);
    },
    getDate(is) {
      var myDate = new Date();
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    fastDate(is) {
      var myDate = new Date(
        new Date().getTime() - 1000 * 60 * 60 * 24 * 31 * 12
      );
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    getDateTime(nS) {
      var date = new Date(nS); //获取一个时间对象
      let y = date.getFullYear(); // 获取完整的年份(4位,1970)
      let m =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)
      let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(); // 获取日(1-31)
      let t = date.getTime() < 10 ? '0' + date.getTime() : date.getTime(); // 获取时间(从1970.1.1开始的毫秒数)
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(); // 获取小时数(0-23)
      let mm =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(); // 获取分钟数(0-59)
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds(); // 获取秒数(0-59)
      return y + '-' + m + '-' + d;
    },
    getOld30() {
      let thirtyDays =
        new Date(new Date().toLocaleDateString()).getTime() -
        30 * 3600 * 24 * 1000; //最近30天
      return this.getDateTime(thirtyDays);
    },

    getList() {
      const shop_id = this.formInline.id;
      const data = {
        shop_id,
        indicators: [
          // 总销售额
          // {
          //   value_type: 'total_sale',
          //   date_type: 'accumulate',
          //   is_date_range: false,
          //   // date_to: this.getDate(true),
          //   // date_from: this.getOld30(),
          //   date: this.getDate(),
          // },

          // 支付宝销售额
          {
            is_date_range: false,
            value_type: 'ali_sale',
            date_type: 'month',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
          // 微信销售额
          {
            is_date_range: false,
            value_type: 'wechat_sale',
            date_type: 'month',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
          //会员充值金额 prepay_sale
          {
            is_date_range: true,
            value_type: 'prepay_sale',
            date_type: 'month',
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
          //会员消费余额 member_sale
          {
            value_type: 'member_sale',
            date_type: 'month',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
          {
            value_type: 'total_sale',
            date_type: 'day',
            is_date_range: true,
            date_to: this.getDate(true),
            date_from: this.getOld30(),
            // date_from: this.formInline.date[1],
            // date_to: this.formInline.date[0],
          },
          //30天订单b
          {
            value_type: 'order_stat',
            date_type: 'day',
            is_date_range: true,
            date_to: this.getDate(true),
            date_from: this.getOld30(),
            // date_from: this.formInline.date[1],
            // date_to: this.formInline.date[0],
          },
          // 营收曲线c
          {
            value_type: 'total_sale',
            date_type: 'month',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
          {
            value_type: 'client_stat',
            date_type: 'day',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
        ],
      };

      const url = this.$userList.show_indicator;
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
          this.datalist = res.data.results;
          this.setDatalist();
        }
      });
    },
    setDatalist() {
      const data = {};
      this.datalist.map((item) => {
        if (item.indicator.date) {
          data[item.indicator.value_type + '' + item.indicator.date] =
            (item.value && item.value.total_price / 100) || 0;
        } else {
          data[item.indicator.value_type + '_' + item.indicator.date_type] =
            item.value;
        }
      });
      this.topValue = data;
      console.log('data: ', data);
      this.topDataMous(data);

      this.drawLine();
      this.drawLines();
      this.drawLinex();
      // {
      //   indicator: {
      //     value_type: 'wechat_sale',
      //     date_type: 'day',
      //     is_date_range: false,
      //     date: '2021-07-01',
      //   },
      //   value: [
      //     {
      //       ID: 1234567,
      //       CreatedAt: '2020-01-19T12:24:32',
      //       UpdatedAt: '1',
      //       shop_id: 1234567,
      //       date: 20210701,
      //       date_display: '2021-07-01',
      //       date_type: 'day',
      //       value_type: 'wechat_sale',
      //       value: 13578,
      //     },
      //   ],
      // },
    },
    topDataMous(data) {
      const prepay_sale = data['prepay_sale_month'];
      const ali_sale = data['ali_sale_month'];

      const wechat_sale = data['wechat_sale_month'];
      const member_sale = data['member_sale_month'];

      if (prepay_sale) {
        let prepay_saleall = 0;
        prepay_sale.map((item) => {
          prepay_saleall += item.total_price;
        });
        this.prepay_saleall = prepay_saleall / 100 || 0;
      }
      if (ali_sale) {
        let ali_saleallall = 0;
        ali_sale.map((item) => {
          ali_saleallall += item.total_price;
        });
        this.ali_saleallall = ali_saleallall / 100 || 0;
      }
      if (wechat_sale) {
        let wechat_saleall = 0;
        wechat_sale.map((item) => {
          wechat_saleall += item.total_price;
        });
        this.wechat_saleall = wechat_saleall / 100 || 0;
      }

      if (member_sale) {
        let member_saleall = 0;
        member_sale.map((item) => {
          member_saleall += item.total_price;
        });
        this.member_saleall = member_saleall / 100 || 0;
      }
    },
    getDateTop() {
      // this.formInline.id = res.data.items[0].id;
      // this.formInline.date = [this.fastDate(true), this.getDate(true)];
      console.log(this.formInline.date);
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295);
}
.back {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295) !important;
  box-sizing: border-box;
  padding: 20px 10px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fcfa;
}
.colMaxBox {
  margin: 5px 0;
}
.top_item {
  box-sizing: border-box;
  padding: 10px 15px;
}
.item_value {
  font-size: 16px;
  line-height: 36px;
  font-weight: bold;
  width: 100%;
  text-align: left;
  color: #878787;
  box-sizing: border-box;
}
.iconCol1 {
  color: #41c300;
}
.iconCol2 {
  color: #00838f;
}
.iconCol3 {
  color: #eeb043;
}
.iconCol4 {
  color: #ed7f7e;
}
.iconCol5 {
  color: rgb(64, 158, 255);
}
.item_name {
  font-size: 14px;
  width: 100%;
  text-align: left;
  margin-top: 10px;

  color: #878787;
  box-sizing: border-box;
  overflow: hidden;
  .iconFloat {
    float: right;
    font-size: 25px;
  }
}
.istopflex {
  justify-content: space-between;
  align-items: center;
  display: flex;
}
</style>
